/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Push tylko po osobnym kliknięciu. Zmiana zestawów aktualizuje wyłącznie
 * już włączoną subskrypcję; serwer otrzymuje kody gier, nigdy liczby ani nazwy. */
(function (root, doc) {
    'use strict';
    var MZ = root.PewniakiZestawy;
    if (!MZ || !doc || doc.documentElement.getAttribute('data-mk-push-start') === '1') { return; }
    doc.documentElement.setAttribute('data-mk-push-start', '1');
    var S = MZ.sklep(), skrot = doc.querySelector('[data-mk-skrot]');
    var jezyk = skrot ? skrot.getAttribute('data-mk-lang') : (doc.documentElement.lang || '');
    // Dynamiczne komunikaty na stronach DE/NL/ES nie mogą wracać do polskiego.
    var jezykKod = String(jezyk || 'pl').toLowerCase().split('-')[0];
    if (['pl', 'en', 'de', 'nl', 'es'].indexOf(jezykKod) < 0) { jezykKod = 'pl'; }
    var en = jezykKod !== 'pl';
    function tlumaczenia() { var el = doc.getElementById('moje-kupony-ui-json'); try { return el ? JSON.parse(el.textContent || '{}') : {}; } catch (e) { return {}; } }
    var ui = tlumaczenia();
    function T(klucz) { var slownik = ui.js_push || {}; return typeof slownik[klucz] === 'string' ? slownik[klucz] : ''; }
    var KLUCZ_PUSH = 'pewniaki-push', KLUCZ_MK = 'pewniaki:moje-kupony:powiadomienia:v1';
    var DB_KUPONY = 'pewniaki-kupony-v1', DB_STORE = 'state', DB_KEY = 'selections';
    var zajety = false, ostatniTekst = '';
    function czytaj(k) { try { return JSON.parse(root.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
    function zapisz(k, v) { try { if (v === null) { root.localStorage.removeItem(k); } else { root.localStorage.setItem(k, JSON.stringify(v)); } } catch (e) { /* brak localStorage */ } }
    function wspiera() { return !!(root.navigator && 'serviceWorker' in root.navigator && 'PushManager' in root && jst("ui.7d31b83313991d4c") in root); }
    function gry() { return S.gry().filter(function (k) { return S.lista(k).length > 0; }); }
    function nazwy(xs) { return xs.map(function (k) { var r = S.reguly(k); return r ? r.nazwa : k; }).join(', '); }
    function wszystkie(sel) { return Array.prototype.slice.call(doc.querySelectorAll(sel)); }
    function ustaw(sel, fn) { wszystkie(sel).forEach(fn); }
    function zapiszMigawke() {
        if (!root.indexedDB) { return; }
        var games = {};
        S.gry().forEach(function (kod) {
            var lista = S.lista(kod);
            if (lista.length) { games[kod] = lista.map(function (z) { return { numbers: z.numbers, extra: z.extra || [] }; }); }
        });
        var req;
        try { req = root.indexedDB.open(DB_KUPONY, 1); } catch (e) { return; }
        req.onupgradeneeded = function () { if (!req.result.objectStoreNames.contains(DB_STORE)) { req.result.createObjectStore(DB_STORE); } };
        req.onsuccess = function () {
            try {
                var db = req.result, tx = db.transaction(DB_STORE, 'readwrite');
                tx.objectStore(DB_STORE).put({ version: 1, games: games }, DB_KEY);
                tx.oncomplete = tx.onerror = tx.onabort = function () { db.close(); };
            } catch (e) { try { req.result.close(); } catch (ignore) {} }
        };
    }
    function rysuj(tekst) {
        if (tekst !== undefined) { ostatniTekst = tekst || ''; }
        var mk = czytaj(KLUCZ_MK), zgoda = wspiera() ? root.Notification.permission : 'unsupported';
        var push = czytaj(KLUCZ_PUSH), id = push && typeof push.id === 'string' && /^[a-f0-9]{64}$/.test(push.id) ? push.id.slice(0, 12) : '';
        ustaw('[data-mk-push-id]', function (x) {
            x.textContent = T('id') + (id || T('noSubscription'));
            x.hidden = false;
        });
        ustaw('[data-mkc-push]', function (x) { x.hidden = false; x.setAttribute('data-mkc-push-stan', zgoda); });
        ustaw('[data-mk-push-wylacz]', function (x) { x.hidden = true; x.disabled = zajety; });
        ustaw('[data-mk-push-wlacz]', function (x) { x.hidden = true; x.disabled = zajety || !gry().length; });
        var komunikat;
        if (zgoda === 'unsupported') {
            komunikat = T('unsupported');
        } else if (zgoda === 'denied') {
            komunikat = T('denied');
        } else if (mk && mk.stan === 'wlaczone' && zgoda === 'granted') {
            komunikat = ostatniTekst || T('enabledFor') + nazwy(mk.gry || []) + '.';
            ustaw('[data-mk-push-wylacz]', function (x) { x.hidden = false; });
        } else {
            komunikat = ostatniTekst || (gry().length
                ? T('off')
                : T('saveFirstHelp'));
            ustaw('[data-mk-push-wlacz]', function (x) { x.hidden = false; });
        }
        ustaw('[data-mk-push-stan]', function (x) { x.textContent = komunikat; });
    }
    function api(dane) {
        return root.fetch('/pwa-api.php', dane ? { method: 'POST', cache: 'no-store', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': dane.csrf }, body: JSON.stringify(dane) } : { cache: 'no-store', credentials: 'same-origin' })
            .then(function (r) { return r.json().then(function (v) { if (!r.ok) { throw new Error(v && v.error ? v.error : 'api'); } return v; }); });
    }
    function klucz64(s) { return Uint8Array.from(root.atob(s.replace(/-/g, '+').replace(/_/g, '/')), function (c) { return c.charCodeAt(0); }); }
    function rejestracja() {
        var p = root.pewniakiSW || root.navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' });
        return Promise.resolve(p).then(function () { return root.navigator.serviceWorker.ready; });
    }
    function wlacz(automatycznie) {
        if (zajety || !wspiera()) { rysuj(); return; }
        var wybrane = gry(), decyzja = czytaj(KLUCZ_MK);
        if (!wybrane.length) { rysuj(T('saveFirst')); return; }
        if (automatycznie && (!decyzja || decyzja.stan !== 'wlaczone' || root.Notification.permission !== 'granted')) { rysuj(); return; }
        if (root.Notification.permission === 'denied') { rysuj(); return; }
        zajety = true; rysuj(T('turningOn'));
        // Pytanie wyłącznie w obsłudze przycisku włączenia, nigdy zapisu zestawu.
        var pozwolenie = root.Notification.permission === 'granted'
            ? Promise.resolve('granted') : Promise.resolve(root.Notification.requestPermission());
        pozwolenie.then(function (wynik) {
            if (wynik !== 'granted') { zapisz(KLUCZ_MK, { stan: 'odmowa' }); throw new Error('odmowa'); }
            return api().then(function (cfg) {
                if (!cfg.enabled) { throw new Error(T('paused')); }
                return rejestracja().then(function (reg) {
                    var stara = czytaj(KLUCZ_PUSH);
                    return reg.pushManager.getSubscription().then(function (sub) {
                        if (sub && !(stara && stara.token)) { return sub.unsubscribe().then(function () { return null; }); }
                        return sub;
                    }).then(function (sub) { return sub || reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: klucz64(cfg.publicKey) }); })
                        .then(function (sub) {
                            var token = stara && stara.token ? stara.token : Array.prototype.map.call(root.crypto.getRandomValues(new Uint8Array(32)), function (b) { return (b < 16 ? '0' : '') + b.toString(16); }).join('');
                            zapisz(KLUCZ_PUSH, { token: token, games: wybrane, id: stara && stara.id });
                            return api({ csrf: cfg.csrf, subscription: sub.toJSON(), games: wybrane, token: token, channel: 'moje-kupony', lang: jst("moje_kupony_push_js.3e90c89d96ea") }).then(function (w) {
                                zapisz(KLUCZ_PUSH, { id: w.id, token: token, games: wybrane });
                                zapisz(KLUCZ_MK, { stan: 'wlaczone', gry: wybrane });
                            });
                        });
                });
            });
        }).then(function () {
            ostatniTekst = T('turnedOn');
        }, function (e) {
            ostatniTekst = e && e.message === 'odmowa'
                ? T('permission')
                : (e && e.message ? e.message : T('enableError'));
        }).then(function () { zajety = false; rysuj(); });
    }
    function wylacz() {
        if (zajety) { return; }
        zajety = true; rysuj(T('turningOff'));
        var stara = czytaj(KLUCZ_PUSH);
        api().then(function (cfg) { return stara && stara.id ? api({ action: 'delete', csrf: cfg.csrf, id: stara.id, token: stara.token }) : null; })
            .then(function () { return wspiera() ? rejestracja().then(function (reg) { return reg.pushManager.getSubscription(); }).then(function (s) { return s ? s.unsubscribe() : null; }) : null; })
            .then(function () {
                zapisz(KLUCZ_PUSH, null); zapisz(KLUCZ_MK, { stan: 'wylaczone' });
                ostatniTekst = T('turnedOff');
            }, function () { ostatniTekst = T('disableError'); })
            .then(function () { zajety = false; rysuj(); });
    }
    doc.addEventListener(MZ.ZDARZENIE, function (e) {
        zapiszMigawke();
        var mk = czytaj(KLUCZ_MK);
        if (mk && mk.stan === 'wlaczone' && root.Notification && root.Notification.permission === 'granted') {
            if (gry().length) { wlacz(true); } else { wylacz(); }
        }
        else { rysuj(); }
    });
    doc.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-mk-otworz]')) { rysuj(); }
        var b = e.target && e.target.closest ? e.target.closest('[data-mk-push-wlacz], [data-mk-push-wylacz]') : null;
        if (!b) { return; }
        if (b.hasAttribute('data-mk-push-wlacz')) { wlacz(false); } else { wylacz(); }
    });
    root.addEventListener('storage', function (e) { if (e.key === KLUCZ_PUSH || e.key === null) { rysuj(); } });
    root.PewniakiKuponyPush = { wlacz: function () { wlacz(false); }, wylacz: wylacz, odswiez: rysuj };
    zapiszMigawke();
    rysuj();
})(window, document);
